import React from 'react';
import { Dialog } from '@leverege/ui-elements';
import MapKeyBody from './MapKeyBody';
import S from './MapKeyMobile.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default class MapKeyMobile extends React.Component {
  render() {
    const {
      show,
      onClose,
      titleBarText,
      objectType
    } = this.props;
    return /*#__PURE__*/_jsx(Dialog.Message, {
      title: titleBarText
      //position="full"
      ,
      icon: "https://recovr-ui-assets.storage.googleapis.com/map-icons/map-key-dialog-icon.png",
      show: show,
      onClose: onClose,
      okay: "Close",
      bodyVariant: "mapKeyBodyMobile",
      okayVariant: "secondary",
      children: /*#__PURE__*/_jsx(MapKeyBody, {
        objectType: objectType
      })
    });
  }
}